<template>
  <el-dialog :visible="true" :before-close="closePop" title="用户设置" class="user-dialog">
    <el-form label-width="100px">
      <el-form-item label="用户信息：">
        <el-input v-model="nickName" class="w200"></el-input><span>（{{info.mobile}}）</span>
      </el-form-item>
      <el-form-item label="所在班级：">
        <el-input v-if="info.className" disabled :value="info.className" class="w200"></el-input>
        <el-select v-else v-model="className" @blur="classInputBlur" filterable allow-create placeholder="请分配班级">
          <el-option v-for="item in classes" :label="item" :value="item" :key="'popClass_' + item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户类型：">
        <el-select v-model="type" filterable placeholder="请选择用户类型">
          <el-option v-for="item in userTypes" :label="item.text" :value="item.value" :key="'userType_' + item.value"></el-option>
        </el-select>
        <el-input v-model="remark" class="w200" placeholder="备注信息"></el-input>
      </el-form-item>
      <el-form-item label="购买记录：">
        <el-table :data="buyRecords" max-height="200" stripe class="records-table">
          <el-table-column align="center" label="购买时间" prop="purTime">
            <template slot-scope="scope">
              <span>{{scope.row.purTime | dateFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="有效期限" prop="exp">
            <template slot-scope="scope">
              <span>{{scope.row.exp | dateFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" prop="status" width="80">
            <template slot-scope="scope">
              <span>{{scope.row.canceled ? '已取消' : (scope.row.active ? '有效' : '已过期' )}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button v-if="scope.row.active" :disabled="buttonDisabled" type="warning" size="mini" @click="cancelClick(scope.row)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="新增购买：">
        <el-radio-group v-model="purType" ref="rangeGroup">
          <el-radio label="2">一学年</el-radio>
          <el-radio label="1">一学期</el-radio>
          <el-radio label="0">自定义</el-radio>
        </el-radio-group>
        <el-date-picker v-model="exp" @focus="purType = '0'" type="date" value-format="yyyy-MM-dd" placeholder="有效期限"></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closePop">取 消</el-button>
      <el-button @click="save" :disabled="buttonDisabled" type="primary">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'userDialog',
  data () {
    return {
      buttonDisabled: false,
      editResult: false,
      classes: [],
      buyRecords: [],
      nickName: '',
      className: '',
      purType: '',
      exp: '',
      type: '',
      remark: ''
    }
  },
  computed: {
    userTypes () {
      return this.$store.getters.userTypes
    }
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  created () {
    if (this.info && this.info.uid) {
      this.nickName = this.info.nick
      this.type = this.info.type || ''
      this.remark = this.info.remark
      this.getRecord()
    } else {
      this.$message.error('参数错误')
      this.closePop()
    }
  },
  mounted () {
    this.bindRangeClick()
    this.classes = this.$store.getters.classes
  },
  methods: {
    closePop () {
      this.$emit('closed', this.editResult)
    },
    save () {
      let obj = {
        uid: this.info.uid,
        nick: this.nickName,
        className: this.className,
        purType: this.purType,
        exp: this.exp,
        type: this.type,
        remark: this.remark
      }
      if (!obj.nick) {
        this.$message.error('请设置昵称')
        return false
      }
      if (!this.info.className && !obj.className) {
        this.$message.error('请给用户分配班级')
        return false
      }
      if (!obj.type) {
        this.$message.error('请选择用户类型')
        return false
      }
      // if (obj.purType === '') {
      //   this.$message.error('请选择购买时间')
      //   return false
      // }
      if (obj.purType === '0' && !obj.exp) {
        this.$message.error('请设置购买日期')
        return false
      }
      this.buttonDisabled = true
      this.$http.post('admin/saveUserInfo', obj)
        .then(response => {
          this.$message.success('保存成功')
          this.editResult = true
          this.closePop()
        })
        .catch(() => {
          this.$message.error('保存失败，请重试')
        })
        .then(() => {
          this.buttonDisabled = false
        })
    },
    getRecord () {
      this.$http.get('admin/purchase?userid=' + this.info.uid)
        .then(response => {
          this.$nextTick(() => {
            this.buyRecords = response
          })
        })
        .catch(() => {
          this.$message.error('获取购买记录失败')
        })
        .then(() => {
          this.loading = false
        })
    },
    classInputBlur (event) {
      if (this.className && this.className !== event.target.value) {
        this.className = event.target.value
      }
    },
    bindRangeClick () {
      this.$nextTick(() => {
        this.$refs.rangeGroup.$children.forEach(radio => {
          // 不能把事件绑定到label上，否则会执行两次click事件
          radio.$el.getElementsByTagName('input')[0].addEventListener('click', () => {
            if (this.purType === radio.label) {
              this.purType = ''
            }
          })
        })
      })
    },
    cancelClick (row) {
      this.buttonDisabled = true
      this.$http.post('admin/cancelpur', [row.id])
        .then(response => {
          row.canceled = true
          row.active = false
        })
        .catch(() => {
          this.$message.error('取消购买失败')
        })
        .then(() => {
          this.buttonDisabled = false
        })
    }
  }
}
</script>

<style lang="scss">
.user-dialog {
  .records-table th {
    padding: 0;
  }
  .w200 {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manager/userDialog.vue